/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { BaselineOffertaDtoFromJSON, BillingDataResultFromJSON, CategoriaNoteDtoFromJSON, CategoriaNoteDtoToJSON, CategoriaNoteListDtoFromJSON, CategoryDtoFromJSON, CategoryDtoToJSON, CompetenzeProgettoDtoFromJSON, DetailContractExternalCostDtoFromJSON, DettagliProgettoDtoFromJSON, DettagliProgettoDtoToJSON, DettaglioProjectDtoFromJSON, FatturaEmessaTabDTOFromJSON, FilterDtoToJSON, ListNoteDtoFromJSON, NoteDtoFromJSON, NoteDtoToJSON, ProjectStatusDtoFromJSON, ProjectStatusDtoToJSON, ProjectTypeDtoFromJSON, ProjectTypeDtoToJSON, SearchFilterDtoFromJSON, SearchProjectResponseDtoFromJSON, } from '../models/index';
/**
 *
 */
export class ControllerProjectApi extends runtime.BaseAPI {
    /**
     * Cambia lo stato di un progetto in REPORTING_CLOSED
     */
    closeRendicontazioneRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['projectId'] == null) {
                throw new runtime.RequiredError('projectId', 'Required parameter "projectId" was null or undefined when calling closeRendicontazione().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/project/{projectId}/closeRendicontazione`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * Cambia lo stato di un progetto in REPORTING_CLOSED
     */
    closeRendicontazione(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.closeRendicontazioneRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Bloccato se la categoria nota e\' associata a una o piu\' note.
     * Elimina una categoria nota
     */
    deleteCategoriaNoteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling deleteCategoriaNote().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/project/categoriaNote/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Bloccato se la categoria nota e\' associata a una o piu\' note.
     * Elimina una categoria nota
     */
    deleteCategoriaNote(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteCategoriaNoteRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Bloccato se la categoria e\' associata a uno o piu\' progetti.
     * Elimina una categoria
     */
    deleteCategoryRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling deleteCategory().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/project/categories/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Bloccato se la categoria e\' associata a uno o piu\' progetti.
     * Elimina una categoria
     */
    deleteCategory(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteCategoryRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Bloccato se referenziato da uno o piu\' progetti.
     * Elimina un project status
     */
    deleteProjectStatusRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling deleteProjectStatus().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/project/project-status/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Bloccato se referenziato da uno o piu\' progetti.
     * Elimina un project status
     */
    deleteProjectStatus(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteProjectStatusRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Bloccato se referenziato da progetti o project cost type.
     * Elimina un project type
     */
    deleteProjectTypeRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling deleteProjectType().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/project/project-type/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Bloccato se referenziato da progetti o project cost type.
     * Elimina un project type
     */
    deleteProjectType(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteProjectTypeRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Recupera la baseline offerta del progetto tramite id
     */
    getBaselineOffertaRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['projectId'] == null) {
                throw new runtime.RequiredError('projectId', 'Required parameter "projectId" was null or undefined when calling getBaselineOfferta().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/project/{projectId}/baseline-offerta`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => BaselineOffertaDtoFromJSON(jsonValue));
        });
    }
    /**
     * Recupera la baseline offerta del progetto tramite id
     */
    getBaselineOfferta(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getBaselineOffertaRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Recupera una categoria nota per id
     */
    getCategoriaNoteByIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling getCategoriaNoteById().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/project/categoriaNote/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CategoriaNoteDtoFromJSON(jsonValue));
        });
    }
    /**
     * Recupera una categoria nota per id
     */
    getCategoriaNoteById(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCategoriaNoteByIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Restituisce tutte le categorie disponibili
     * Recupera tutte le categorie disponibili
     */
    getCategoriesRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/project/categories`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CategoryDtoFromJSON));
        });
    }
    /**
     * Restituisce tutte le categorie disponibili
     * Recupera tutte le categorie disponibili
     */
    getCategories(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCategoriesRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Recupera una categoria per id
     */
    getCategoryByIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling getCategoryById().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/project/categories/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CategoryDtoFromJSON(jsonValue));
        });
    }
    /**
     * Recupera una categoria per id
     */
    getCategoryById(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCategoryByIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Recupera le competenze complessive dell\'anno  per il progetto
     */
    getCompetenzeAnnoRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['projectId'] == null) {
                throw new runtime.RequiredError('projectId', 'Required parameter "projectId" was null or undefined when calling getCompetenzeAnno().');
            }
            if (requestParameters['anno'] == null) {
                throw new runtime.RequiredError('anno', 'Required parameter "anno" was null or undefined when calling getCompetenzeAnno().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/project/{projectId}/{anno}/competenze-anno`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))).replace(`{${"anno"}}`, encodeURIComponent(String(requestParameters['anno']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CompetenzeProgettoDtoFromJSON(jsonValue));
        });
    }
    /**
     * Recupera le competenze complessive dell\'anno  per il progetto
     */
    getCompetenzeAnno(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCompetenzeAnnoRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Recupera le competenze complessive dell\'anno corrente per il progetto
     */
    getCompetenzeAnnoCorrenteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['projectId'] == null) {
                throw new runtime.RequiredError('projectId', 'Required parameter "projectId" was null or undefined when calling getCompetenzeAnnoCorrente().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/project/{projectId}/competenze-anno-corrente`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CompetenzeProgettoDtoFromJSON(jsonValue));
        });
    }
    /**
     * Recupera le competenze complessive dell\'anno corrente per il progetto
     */
    getCompetenzeAnnoCorrente(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCompetenzeAnnoCorrenteRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Recupera le competenze complessive del progetto tramite id
     */
    getCompetenzeComplessiveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['projectId'] == null) {
                throw new runtime.RequiredError('projectId', 'Required parameter "projectId" was null or undefined when calling getCompetenzeComplessive().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/project/{projectId}/competenze-complessive`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CompetenzeProgettoDtoFromJSON(jsonValue));
        });
    }
    /**
     * Recupera le competenze complessive del progetto tramite id
     */
    getCompetenzeComplessive(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCompetenzeComplessiveRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Prende in input l\'ID del progetto e restituisce tutti gli External Costs associati, raggruppati per tripletta (groupId, quoteId, costTypeId).
     * Recupera gli i contratti associati agli External Costs tramite il Project ID
     */
    getExternalCostsByProjectRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['projectId'] == null) {
                throw new runtime.RequiredError('projectId', 'Required parameter "projectId" was null or undefined when calling getExternalCostsByProject().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/project/project/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DetailContractExternalCostDtoFromJSON));
        });
    }
    /**
     * Prende in input l\'ID del progetto e restituisce tutti gli External Costs associati, raggruppati per tripletta (groupId, quoteId, costTypeId).
     * Recupera gli i contratti associati agli External Costs tramite il Project ID
     */
    getExternalCostsByProject(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getExternalCostsByProjectRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Restituisce tutte le categorie delle note  disponibili
     * Recupera tutte le categorie delle note disponibili
     */
    getNoteCategoriesRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/project/categoriaNote`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CategoriaNoteListDtoFromJSON(jsonValue));
        });
    }
    /**
     * Restituisce tutte le categorie delle note  disponibili
     * Recupera tutte le categorie delle note disponibili
     */
    getNoteCategories(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getNoteCategoriesRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Project status per id
     */
    getProjectStatusRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling getProjectStatus().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/project/project-status/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ProjectStatusDtoFromJSON(jsonValue));
        });
    }
    /**
     * Project status per id
     */
    getProjectStatus(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getProjectStatusRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Elenco project status
     */
    getProjectStatusesRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/project/project-status`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProjectStatusDtoFromJSON));
        });
    }
    /**
     * Elenco project status
     */
    getProjectStatuses(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getProjectStatusesRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Project type per id
     */
    getProjectTypeRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling getProjectType().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/project/project-type/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ProjectTypeDtoFromJSON(jsonValue));
        });
    }
    /**
     * Project type per id
     */
    getProjectType(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getProjectTypeRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Elenco project type
     */
    getProjectTypesRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/project/project-type`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProjectTypeDtoFromJSON));
        });
    }
    /**
     * Elenco project type
     */
    getProjectTypes(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getProjectTypesRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Recupera i dati di fatturazione legati all\'opportunity
     * Dati di fatturazione
     */
    projectBillingRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['projectId'] == null) {
                throw new runtime.RequiredError('projectId', 'Required parameter "projectId" was null or undefined when calling projectBilling().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/project/{projectId}/billing-data`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => BillingDataResultFromJSON(jsonValue));
        });
    }
    /**
     * Recupera i dati di fatturazione legati all\'opportunity
     * Dati di fatturazione
     */
    projectBilling(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.projectBillingRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Modifica i dati non null del progetto passati in input, basandosi sui permessi dell\'utente loggato
     * Modifica dati progetto
     */
    projectDataUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['dettagliProgettoDto'] == null) {
                throw new runtime.RequiredError('dettagliProgettoDto', 'Required parameter "dettagliProgettoDto" was null or undefined when calling projectDataUpdate().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/project/edit-project`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: DettagliProgettoDtoToJSON(requestParameters['dettagliProgettoDto']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => DettagliProgettoDtoFromJSON(jsonValue));
        });
    }
    /**
     * Modifica i dati non null del progetto passati in input, basandosi sui permessi dell\'utente loggato
     * Modifica dati progetto
     */
    projectDataUpdate(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.projectDataUpdateRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Elimina il messaggio passandogli l\'id del messaggio
     * Elimina messaggio
     */
    projectDeleteMessageRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['messageId'] == null) {
                throw new runtime.RequiredError('messageId', 'Required parameter "messageId" was null or undefined when calling projectDeleteMessage().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/project/messages/{messageId}/delete`.replace(`{${"messageId"}}`, encodeURIComponent(String(requestParameters['messageId']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => NoteDtoFromJSON(jsonValue));
        });
    }
    /**
     * Elimina il messaggio passandogli l\'id del messaggio
     * Elimina messaggio
     */
    projectDeleteMessage(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.projectDeleteMessageRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Prende in input l\'ID e restituisce l\'output dell\'elemento con quell\'ID
     * Recupera il progetto tramite id
     */
    projectDetailRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['projectId'] == null) {
                throw new runtime.RequiredError('projectId', 'Required parameter "projectId" was null or undefined when calling projectDetail().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/project/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => DettaglioProjectDtoFromJSON(jsonValue));
        });
    }
    /**
     * Prende in input l\'ID e restituisce l\'output dell\'elemento con quell\'ID
     * Recupera il progetto tramite id
     */
    projectDetail(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.projectDetailRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Recupera tutti i progetti presenti nel sistema
     * Recupera tutti i progetti in evidenza
     */
    projectEvidenzaRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/project`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SearchProjectResponseDtoFromJSON(jsonValue));
        });
    }
    /**
     * Recupera tutti i progetti presenti nel sistema
     * Recupera tutti i progetti in evidenza
     */
    projectEvidenza(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.projectEvidenzaRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Recupera i dati delle fatture emesse
     * Dati delle fatture emesse
     */
    projectFattureEmesseRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['projectId'] == null) {
                throw new runtime.RequiredError('projectId', 'Required parameter "projectId" was null or undefined when calling projectFattureEmesse().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/project/{projectId}/fatture-emesse`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FatturaEmessaTabDTOFromJSON));
        });
    }
    /**
     * Recupera i dati delle fatture emesse
     * Dati delle fatture emesse
     */
    projectFattureEmesse(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.projectFattureEmesseRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Recupera i messaggi legati al progetto
     * Recupera i messaggi legati al progetto
     */
    projectGetMessageRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['projectId'] == null) {
                throw new runtime.RequiredError('projectId', 'Required parameter "projectId" was null or undefined when calling projectGetMessage().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/project/{projectId}/messages`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ListNoteDtoFromJSON(jsonValue));
        });
    }
    /**
     * Recupera i messaggi legati al progetto
     * Recupera i messaggi legati al progetto
     */
    projectGetMessage(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.projectGetMessageRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Inserisci il messaggio passandogli l\'id del progetto e il testo del messaggio
     * Inserisci messaggio
     */
    projectInsertMessageRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['projectId'] == null) {
                throw new runtime.RequiredError('projectId', 'Required parameter "projectId" was null or undefined when calling projectInsertMessage().');
            }
            if (requestParameters['noteDto'] == null) {
                throw new runtime.RequiredError('noteDto', 'Required parameter "noteDto" was null or undefined when calling projectInsertMessage().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/project/{projectId}/insertMessage`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: NoteDtoToJSON(requestParameters['noteDto']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => NoteDtoFromJSON(jsonValue));
        });
    }
    /**
     * Inserisci il messaggio passandogli l\'id del progetto e il testo del messaggio
     * Inserisci messaggio
     */
    projectInsertMessage(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.projectInsertMessageRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Recupera tutti i progetti presenti nel sistema tramite filtri
     * Recupera tutti i progetti tramite i filtri
     */
    projectSearchRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['filterDto'] == null) {
                throw new runtime.RequiredError('filterDto', 'Required parameter "filterDto" was null or undefined when calling projectSearch().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/project/search`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: FilterDtoToJSON(requestParameters['filterDto']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SearchProjectResponseDtoFromJSON(jsonValue));
        });
    }
    /**
     * Recupera tutti i progetti presenti nel sistema tramite filtri
     * Recupera tutti i progetti tramite i filtri
     */
    projectSearch(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.projectSearchRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Recupera tutti i filtri di ricerca per un progetto
     * Recupera tutti i filtri di ricerca
     */
    projectSearchFilterRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/project/filtri-ricerca`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SearchFilterDtoFromJSON(jsonValue));
        });
    }
    /**
     * Recupera tutti i filtri di ricerca per un progetto
     * Recupera tutti i filtri di ricerca
     */
    projectSearchFilter(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.projectSearchFilterRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Modifica il messaggio passandogli l\'id del messaggio e il testo del messaggio
     * Modifica messaggio
     */
    projectUpdateMessageRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['messageId'] == null) {
                throw new runtime.RequiredError('messageId', 'Required parameter "messageId" was null or undefined when calling projectUpdateMessage().');
            }
            if (requestParameters['noteDto'] == null) {
                throw new runtime.RequiredError('noteDto', 'Required parameter "noteDto" was null or undefined when calling projectUpdateMessage().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/project/messages/{messageId}/update`.replace(`{${"messageId"}}`, encodeURIComponent(String(requestParameters['messageId']))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: NoteDtoToJSON(requestParameters['noteDto']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => NoteDtoFromJSON(jsonValue));
        });
    }
    /**
     * Modifica il messaggio passandogli l\'id del messaggio e il testo del messaggio
     * Modifica messaggio
     */
    projectUpdateMessage(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.projectUpdateMessageRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Se il DTO ha id valorizzato aggiorna, altrimenti crea.
     * Crea o modifica una categoria nota
     */
    saveCategoriaNoteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['categoriaNoteDto'] == null) {
                throw new runtime.RequiredError('categoriaNoteDto', 'Required parameter "categoriaNoteDto" was null or undefined when calling saveCategoriaNote().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/project/categoriaNote`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CategoriaNoteDtoToJSON(requestParameters['categoriaNoteDto']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CategoriaNoteDtoFromJSON(jsonValue));
        });
    }
    /**
     * Se il DTO ha id valorizzato aggiorna, altrimenti crea.
     * Crea o modifica una categoria nota
     */
    saveCategoriaNote(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.saveCategoriaNoteRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Se il DTO ha id valorizzato aggiorna, altrimenti crea.
     * Crea o modifica una categoria
     */
    saveCategoryRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['categoryDto'] == null) {
                throw new runtime.RequiredError('categoryDto', 'Required parameter "categoryDto" was null or undefined when calling saveCategory().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/project/categories`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CategoryDtoToJSON(requestParameters['categoryDto']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CategoryDtoFromJSON(jsonValue));
        });
    }
    /**
     * Se il DTO ha id valorizzato aggiorna, altrimenti crea.
     * Crea o modifica una categoria
     */
    saveCategory(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.saveCategoryRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Se il DTO ha id valorizzato aggiorna, altrimenti crea. La logica resta guidata da StatoEnum.
     * Crea o modifica un project status
     */
    saveProjectStatusRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['projectStatusDto'] == null) {
                throw new runtime.RequiredError('projectStatusDto', 'Required parameter "projectStatusDto" was null or undefined when calling saveProjectStatus().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/project/project-status`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ProjectStatusDtoToJSON(requestParameters['projectStatusDto']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ProjectStatusDtoFromJSON(jsonValue));
        });
    }
    /**
     * Se il DTO ha id valorizzato aggiorna, altrimenti crea. La logica resta guidata da StatoEnum.
     * Crea o modifica un project status
     */
    saveProjectStatus(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.saveProjectStatusRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Se il DTO ha id valorizzato aggiorna, altrimenti crea. La logica resta guidata da TipologiaEnum.
     * Crea o modifica un project type
     */
    saveProjectTypeRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['projectTypeDto'] == null) {
                throw new runtime.RequiredError('projectTypeDto', 'Required parameter "projectTypeDto" was null or undefined when calling saveProjectType().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/project/project-type`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ProjectTypeDtoToJSON(requestParameters['projectTypeDto']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ProjectTypeDtoFromJSON(jsonValue));
        });
    }
    /**
     * Se il DTO ha id valorizzato aggiorna, altrimenti crea. La logica resta guidata da TipologiaEnum.
     * Crea o modifica un project type
     */
    saveProjectType(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.saveProjectTypeRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Modifica i dati non null del progetto intranet passati in input, basandosi sui permessi dell\'utente loggato
     * Modifica dati progetto intranet
     */
    updateProjectIntranetDataRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['projectId'] == null) {
                throw new runtime.RequiredError('projectId', 'Required parameter "projectId" was null or undefined when calling updateProjectIntranetData().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/project/edit-project-intranet/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * Modifica i dati non null del progetto intranet passati in input, basandosi sui permessi dell\'utente loggato
     * Modifica dati progetto intranet
     */
    updateProjectIntranetData(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateProjectIntranetDataRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
